module.exports = __webpack_public_path__ + "img/ArrowWhite.aeb58287.svg";